// Pathway selection UI for manager assignment
function initPathwaySelector() {
  const cards = document.querySelectorAll('[data-pathway-selectable]')
  const confirmBar = document.getElementById('pathway-assign-confirm-bar')
  const confirmText = document.getElementById('pathway-assign-confirm-text')
  const pathwayIdField = document.getElementById('pathway_id_field')
  const form = document.getElementById('pathway-assign-form')
  const cancelBtn = document.getElementById('pathway-assign-cancel')
  const confirmBtn = document.getElementById('pathway-assign-confirm')

  if (!confirmBar || !form) return

  let selectedCard = null

  cards.forEach(function (card) {
    card.style.cursor = 'pointer'
    card.addEventListener('click', function () {
      if (selectedCard) {
        selectedCard.classList.remove('pathway-assign-card--selected')
      }

      selectedCard = card
      card.classList.add('pathway-assign-card--selected')

      const pathwayId = card.dataset.pathwayId
      const pathwayName = card.dataset.pathwayName
      pathwayIdField.value = pathwayId
      confirmText.textContent = confirmText.dataset.template
        .replace('%{pathway}', pathwayName)

      confirmBar.classList.remove('d-none')
    })

    // Keyboard accessibility
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        card.click()
      }
    })
  })

  if (cancelBtn) {
    cancelBtn.addEventListener('click', function () {
      if (selectedCard) {
        selectedCard.classList.remove('pathway-assign-card--selected')
        selectedCard = null
      }
      pathwayIdField.value = ''
      confirmBar.classList.add('d-none')
    })
  }

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      if (pathwayIdField.value) {
        confirmBtn.disabled = true
        confirmBtn.textContent = '...'
        form.requestSubmit()
      }
    })
  }
}

document.addEventListener('turbo:load', initPathwaySelector)
